import { render } from "./AutoCompleteInput.vue?vue&type=template&id=127135a2"
import script from "./AutoCompleteInput.vue?vue&type=script&lang=js"
export * from "./AutoCompleteInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__